import {
  StyledAlert,
  WrapLgMarginBottom,
  WrapMdMarginBottom,
} from "App/global-style";
import { AlertType, ContactUsAlert } from "Components/Form/Alert";
import React, { useState } from "react";
import {
  getCoverageAmountErrorMessage,
  isCoverageSumTooHigh,
} from "../houseProductsUtils";

import { NumericInput } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { HouseContentsCalculator } from "Components/HouseContentsCalculator/HouseContentsCalculator";
import { useTexts } from "Components/TextContext";
import { Button } from "Components/TextContext/commonComponentEnums";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { buttonTrackId } from "Utils/analytics";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";

interface Props {
  name: string;
  label: string;
  hint: string;
  formProps: FormikProps<any>;
  productId: ProductBackendName;
  isFullRental: boolean;
  handleCalculatorSubmit: (event?: any, formProps?: FormikProps<any>) => void;
}

export const CoverageAndCalculator = ({
  name,
  label,
  hint,
  formProps,
  handleCalculatorSubmit,
  isFullRental,
  productId,
}: Props): React.ReactElement => {
  const [isVisible, setIsVisible] = useState(false);
  const { getText } = useTexts();
  const isCoverageTooHigh = isCoverageSumTooHigh(
    productId,
    isFullRental,
    String(formProps.values[name]),
  );

  const openCalculatorButton = (
    <ThemedButton
      className="InsuranceCoverageAmountCalculatorBTN"
      variant="outlined"
      type="button"
      aria-haspopup="dialog"
      onClick={() => {
        setIsVisible(!isVisible);
      }}
      trackId={buttonTrackId("open-house-contents-calculator")}
    >
      {getText(Button.GET_INSURANCE_SUM)}
    </ThemedButton>
  );

  return (
    <>
      <NumericInput
        name={name}
        id={name}
        large
        label={label}
        hint={hint}
        inputMode={InputMode.NUMERIC}
        error={getError(name, formProps)}
        inputProps={{
          autoComplete: "off",
        }}
      />
      {isFullRental && isCoverageTooHigh && (
        <StyledAlert
          type="error"
          alertId={name}
          alertType={AlertType.STOPPER_ALERT}
          title={getText(
            "housecontentsform.alerttitle.coverageamount-toohighrental",
          )}
          description={getCoverageAmountErrorMessage(productId, isFullRental)}
          fluid
        />
      )}
      {!isFullRental && isCoverageTooHigh && (
        <WrapMdMarginBottom>
          <ContactUsAlert
            description={getCoverageAmountErrorMessage(productId, isFullRental)}
            title={getText(
              "housecontentsform.alerttitle.coverageamount-toohigh",
            )}
            alertId={name}
          />
        </WrapMdMarginBottom>
      )}

      <WrapLgMarginBottom>{openCalculatorButton}</WrapLgMarginBottom>
      {isVisible && (
        <HouseContentsCalculator
          product={productId}
          handleSubmit={handleCalculatorSubmit}
          isVisible={isVisible}
          toggleVisible={setIsVisible}
          trigger={openCalculatorButton}
          isFullRental={isFullRental}
          errorMessage={getCoverageAmountErrorMessage(productId, isFullRental)}
        />
      )}
    </>
  );
};
